import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0566af8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col pt-2" }
const _hoisted_2 = { class: "flex flex-grow flex-col pl-3 w-56" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "From:", -1))
const _hoisted_5 = { class: "text-xs pl-2 truncate" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "To:", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_10 = { class: "flex justify-end pr-2 whitespace-nowrap" }
const _hoisted_11 = { class: "flex flex-col text-xs" }
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "flex flex-row font-light" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xxs italic pt-1" }, "@", -1))
const _hoisted_15 = { class: "pl-1" }
const _hoisted_16 = { class: "italic font-light" }
const _hoisted_17 = { class: "flex flex-row pl-7 pt-2 pr-20" }
const _hoisted_18 = { class: "text-xs font-medium truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col border-bottom pt-2 pb-3 pl-2 cursor-pointer", _ctx.selected && 'selected'])
  }, [
    _createElementVNode("div", {
      class: "flex flex-row align-items-center",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clicked && _ctx.clicked(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (_ctx.email.attachments !== null)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: ['fas', 'paperclip']
              }))
            : _createCommentVNode("", true),
          (_ctx.email.isReadBySelf === false)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: ['fas', 'circle'],
                class: "text-primary text-xs"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSelected) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.internalSelected]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.email.from), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "text-xs pl-4 truncate",
            title: _ctx.email.to.length > 1 ? _ctx.getAddressToolTip(_ctx.email.to) : ''
          }, [
            _createTextVNode(_toDisplayString(_ctx.email.to[0]) + " ", 1),
            (_ctx.email.to.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`+${_ctx.email.to.length - 1}`), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.email.dateCreated.split("T")[0]), 1),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.email.dateCreated.split("T")[1].split(":")[0]) + ":" + _toDisplayString(_ctx.email.dateCreated.split("T")[1].split(":")[1]), 1)
          ]),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$filters.dateTimeRelative(_ctx.email.dateCreated)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.email.subject), 1)
    ])
  ], 2))
}